import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {baseFill, baseStroke} from '../shared/partVariants';

interface RightMiddlePillarProps {
  readonly mode?: PartMode;
  readonly onClick?: () => void;
}

export function RightMiddlePillar(props: RightMiddlePillarProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Right Middle Pillar"
      width={50}
      height={30}
      viewBox="0 0 50 30"
      position={{top: 33, left: 693}}
    >
      <path
        d="M1 17V1H48.9884V17C49.1585 20.8333 47.559 29 37.7571 29H12.2313C2.02103 29 1 22 1 17Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M1 17V1H49V16C49 20 48 29 38 29H12C1 29 1 21.011 1 17Z"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
    </PartSvg>
  );
}
